import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { mutations, getters } from "@/store";

let appInsights;
export let trackEvent = () => {};
export let trackException = () => {};

export default {
  install(Vue, options) {
    if (!Vue.prototype.$trackEvent) {
      Object.defineProperty(Vue.prototype, "$trackEvent", {
        get: () => trackEvent
      });
    }
    if (!Vue.prototype.$trackException) {
      Object.defineProperty(Vue.prototype, "$trackException", {
        get: () => trackException
      });
    }

    if (appInsights) return;
    if (!options) return;
    const { router, store, config } = options;
    if (!config?.instrumentationKey) return;

    const getCustomProperties = () => ({
      authenticatedUserId: store?.getters[getters.identityUserId],
      currentIdentificationId:
        store?.getters[getters.currentIdentification]?.identificationId
    });

    trackEvent = ({ name, properties }) => {
      const event = {
        name,
        properties: { ...properties, ...getCustomProperties(store) }
      };
      appInsights?.trackEvent(event);
    };

    trackException = ({ exception, properties }) => {
      const event = {
        exception,
        properties: { ...properties, ...getCustomProperties(store) }
      };
      appInsights?.trackException(event);
    };

    appInsights = new ApplicationInsights({ config });
    appInsights.loadAppInsights();

    // profile.name is the operator's email -- the backend already takes it as
    // userEmail -- so telemetry can be filtered by person without resolving the
    // opaque `sub`. Set here rather than in getCustomProperties so it also
    // reaches page views, exceptions and dependencies.
    appInsights.addTelemetryInitializer(item => {
      const userEmail = store?.getters[getters.identityUserName];
      if (!userEmail) return;

      item.data = item.data || {};
      item.data.userEmail = userEmail;
    });

    if (router) {
      router.afterEach(() => {
        appInsights.trackPageView();
      });
    }

    if (store) {
      store.subscribe(async mutation => {
        const { type, payload } = mutation;
        trackEvent({
          name: `mutation/${type}`,
          properties: { payload }
        });
        const authenticatedUserId = store.getters[getters.identityUserId];
        switch (type) {
          case mutations.identityInit:
          case mutations.userLoaded:
          case mutations.userUnloaded:
          case mutations.accessTokenExpired:
          case mutations.userSignedOut:
            if (authenticatedUserId) {
              appInsights.setAuthenticatedUserContext(
                authenticatedUserId,
                null,
                true
              );
            } else {
              appInsights.clearAuthenticatedUserContext();
            }
            break;
        }
      });
    }
  }
};
